import type {
  CONTENTS,
  DEVICE_TYPES,
  GENERIC_SIZES,
  SIDEBAR_OPTIONS,
  SLOT_PARAMS,
} from '../types/Blocks'

import { devices } from './devices'

export const generateForAllDevice = <T, G extends { [d in DEVICE_TYPES]: T }>(
  value: T,
  deviceData?: G,
  fixedData?: G
) => {
  const data: { [key in DEVICE_TYPES]?: T } = {}
  Object.keys(devices).forEach((type) => {
    const t = type as DEVICE_TYPES
    data[t] = {
      ...deviceData?.[t],
      ...value,
      ...fixedData?.[t],
    }
  })
  return data as { [key in DEVICE_TYPES]: T }
}

export const APOSTROPHE_REPLACEMENT = '%%00_apost_00%%'

export const ONE_REM = 16

export const EMPTY_OBJECT = Object.freeze({})
export const EMPTY_ARRAY = Object.freeze([])

export const DEFAULT_GAP = () => ({
  cols: {
    value: 1,
    unit: 'rem',
  },
  rows: {
    value: 1,
    unit: 'rem',
  },
})

export const DEFAULT_WIDTH = () => ({
  value: 100,
  unit: '%',
})

export const DEFAULT_MARGIN = (): GENERIC_SIZES => ({
  top: { value: 0, unit: 'rem' },
  right: { value: 0, unit: 'rem' },
  bottom: { value: 0, unit: 'rem' },
  left: { value: 0, unit: 'rem' },
})

export const DEFAULT_PADDING = (): GENERIC_SIZES => ({
  top: { value: 0, unit: 'rem' },
  right: { value: 0, unit: 'rem' },
  bottom: { value: 0, unit: 'rem' },
  left: { value: 0, unit: 'rem' },
})

export const DEFAULT_BORDERS = (): GENERIC_SIZES => ({
  top: { value: 0, unit: 'rem' },
  right: { value: 0, unit: 'rem' },
  bottom: { value: 0, unit: 'rem' },
  left: { value: 0, unit: 'rem' },
})

export const DEFAULT_CONTENTS = (): CONTENTS => ({
  article: {},
  branch: {},
  document: {},
  product: {},
  tag: {},
})

export const DEFAULT_SLOT_PARAMS = (): SLOT_PARAMS => ({
  justify: 'flex-start',
})

export const DEFAULT_SIDEBAR_OPTIONS = (): SIDEBAR_OPTIONS => ({
  general: true,
  css: true,
  advanced: true,
  interactions: true,
})

export const THUMBS = {
  header: { fm: 'webp' },
  placeholder: { style: '3xs' },
  xs: { style: 'xs' },
  s: { style: 's' },
  m: { style: 'm' },
  l: { style: 'l' },
  xl: { style: 'xl' },
  '2xl': { style: '2xl' },
}

export const PRODUCT_DETAIL_THUMBS = {
  header: { fm: 'webp' },
  xs: { fm: 'webp', q: 80, w: 128, h: 128, fit: 'fill' },
  s: { fm: 'webp', q: 80, w: 360, h: 360, fit: 'fill' },
  m: { fm: 'webp', q: 80, w: 650, h: 650, fit: 'fill' },
  l: { fm: 'webp', q: 80, w: 1300, h: 1300, fit: 'fill' },
  xl: { fm: 'webp', q: 80, w: 1920, h: 1920, fit: 'fill' },
  '2xl': { fm: 'webp', q: 80, w: 2560, h: 2560, fit: 'fill' },
}

export const NOT_ASSIGNED_KEY = 'not-assigned'
